module.exports = __webpack_public_path__ + "img/23_105.8225fe69.png";